module.exports = __webpack_public_path__ + "static/media/calendar.8410a4c6.svg";